export default {
    // COMMON
    black: '#000000',
    white: '#FFFFFF',
    // CHART COLORS
    chartBlue: '#00B5D1',
    chartBlueDark: '#33A0D8',
    chartGray: '#425160',
    chartRed: '#F05336',
    chartBarracudaGreen: '#29A37A',
    chartBarracudaOrange: '#FFCC66',
    chartBarracudaLightBlue: '#0DCCF2',
    chartBarracudaDarkBlue: '#265973',
    chartBarracudalightPurple: '#B1A3F5',
    chartBarracudaDarkPurple: '#660AC2',
    chartBarracudaTan: '#E0CCB8',
    chartBarracudaMagenta: '#AD1FAD',
    chartBarracudaMossGreen: '#B1A3F5',
    chartBarracudaPink: '#F5A3F5',
    chartBarracudaDarkOranage: '#E65D19',
    chartBarracudaDarkBrown: '#734D26',
    // BLUE (Hue 200)
    blue050: '#E4F4FF',
    blue100: '#C8E9FF',
    blue200: '#A1D3F3',
    blue300: '#7CBDE6',
    blue400: '#56A7DA',
    blue500: '#2F92CE',
    blue600: '#067CC1',
    blue700: '#0A5D91',
    blue800: '#053C60',
    blue900: '#001D30',
    // COASTAL SAND
    coastalSand025: '#FAF9F4',
    coastalSand050: '#F5F3E9',
    coastalSand100: '#E9E6D9',
    coastalSand150: '#DED9C9',
    coastalSand200: '#D1CEBF',
    coastalSand300: '#B7B7A9',
    coastalSand400: '#9B9D93',
    coastalSand500: '#81827C',
    coastalSand600: '#676864',
    coastalSand700: '#4D4E4C',
    coastalSand800: '#343433',
    coastalSand900: '#1A1A1A',
    // DEEP OCEAN
    deepOcean050: '#E1E8F6',
    deepOcean100: '#CDD7EB',
    deepOcean150: '#BAC8E0',
    deepOcean200: '#A8B9D5',
    deepOcean025: '#F0F3FA',
    deepOcean300: '#8EA1BD',
    deepOcean400: '#7589A5',
    deepOcean500: '#5E728D',
    deepOcean600: '#4A5B76',
    deepOcean700: '#37465E',
    deepOcean800: '#263146',
    deepOcean900: '#1B1C23',
    // FOREST (Hue 140)
    forest050: '#DDF7E6',
    forest100: '#BDEFCE',
    forest200: '#93DAAB',
    forest300: '#6DC58B',
    forest400: '#49B06C',
    forest500: '#279B4F',
    forest600: '#088634',
    forest700: '#096528',
    forest800: '#04431A',
    forest900: '#00210B',
    // GREEN (Hue 100)
    green100: '#C4EDA7',
    green200: '#9FD86E',
    green300: '#82C341',
    green400: '#66AA28',
    green050: '#DBF6CA',
    green500: '#4E9018',
    green600: '#3B770E',
    green700: '#2B5E08',
    green800: '#1D4405',
    green900: '#112B03',
    // HUMPBACK GRAY
    humpbackGray025: '#F3F8FB',
    humpbackGray050: '#E7F1F6',
    humpbackGray100: '#D5E4EB',
    humpbackGray150: '#C4D8E1',
    humpbackGray200: '#B4CBD6',
    humpbackGray300: '#9BB3BE',
    humpbackGray400: '#829AA7',
    humpbackGray500: '#6B828F',
    humpbackGray600: '#566978',
    humpbackGray700: '#425160',
    humpbackGray800: '#333740',
    humpbackGray900: '#1D1D20',
    // INDIGO (Hue 230)
    indigo050: '#F1F3FB',
    indigo100: '#E4E7F6',
    indigo200: '#C8CDE5',
    indigo300: '#ADB3D4',
    indigo400: '#9199C3',
    indigo500: '#747EB2',
    indigo600: '#5460A1',
    indigo700: '#343F79',
    indigo800: '#182150',
    indigo900: '#040A28',
    // MAGENTA (Hue 320)
    magenta050: '#FFECFB',
    magenta100: '#FFD8F6',
    magenta200: '#FCB7E5',
    magenta300: '#F396D4',
    magenta400: '#E974C2',
    magenta500: '#E04FAF',
    magenta600: '#D6269B',
    magenta700: '#A11C74',
    magenta800: '#6B0D4C',
    magenta900: '#350124',
    // ORANGE (Hue 29)
    orange050v2: '#F8ECE7',
    orange050: '#FFEDD0',
    orange100: '#FFE6AE',
    orange200: '#FFD271',
    orange300: '#FFC63B',
    orange400: '#DDA021',
    orange500: '#BB7F11',
    orange600: '#996109',
    orange700: '#774705',
    orange800: '#563003',
    orange900: '#341C03',
    // PINK (Hue 305)
    pink050: '#FEEDFB',
    pink100: '#FDDCF8',
    pink200: '#EFBEE8',
    pink300: '#E19FD9',
    pink400: '#D481CA',
    pink500: '#C660BB',
    pink600: '#B83DAC',
    pink700: '#8A287F',
    pink800: '#5C1252',
    pink900: '#2E0328',
    // PURPLE (Hue 264)
    purple050: '#F5F1FB',
    purple100: '#EDE3F6',
    purple200: '#D9C8E5',
    purple300: '#C6ACD4',
    purple400: '#B390C3',
    purple500: '#A273B2',
    purple600: '#9253A1',
    purple700: '#643479',
    purple800: '#3A1750',
    purple900: '#160428',
    // RED (Hue 0)
    red050: '#FFEEEE',
    red100: '#FFDDDD',
    red200: '#FFBEBE',
    red300: '#F79F9F',
    red400: '#EF7E7E',
    red500: '#E65A5A',
    red600: '#DE3131',
    red700: '#A72323',
    red800: '#6F1010',
    red900: '#380202',
    // RED ORANGE (Hue 18)
    redOrange050: '#FFE8DA',
    redOrange100: '#FFDAC4',
    redOrange200: '#FFB892',
    redOrange300: '#FF9563',
    redOrange400: '#FF763B',
    redOrange500: '#DF5C24',
    redOrange600: '#B94615',
    redOrange700: '#90330C',
    redOrange800: '#652307',
    redOrange900: '#3A1404',
    // ROSE (Hue 346)
    rose050: '#FFEDF1',
    rose100: '#FFDCE3',
    rose200: '#F6BDC7',
    rose300: '#EB9EAA',
    rose400: '#E07E8C',
    rose500: '#D45C6B',
    rose600: '#C93645',
    rose700: '#972534',
    rose800: '#64111F',
    rose900: '#32020C',
    // SCALE GRAY
    scaleGray025: '#F7F7F7',
    scaleGray050: '#EFF0EF',
    scaleGray100: '#E2E2E1',
    scaleGray150: '#D4D4D3',
    scaleGray200: '#C8C8C7',
    scaleGray300: '#AFAFAE',
    scaleGray400: '#969695',
    scaleGray500: '#7D7D7D',
    scaleGray600: '#646464',
    scaleGray700: '#4B4B4B',
    scaleGray800: '#323232',
    scaleGray900: '#191919',
    // SKY BLUE (Hue 190)
    skyBlue050: '#CEF6FD',
    skyBlue100: '#9EEDFC',
    skyBlue200: '#66DAEE',
    skyBlue300: '#31C7DF',
    skyBlue400: '#00B5D1',
    skyBlue500: '#0F98AE',
    skyBlue600: '#147A8B',
    skyBlue700: '#105B69',
    skyBlue800: '#073C46',
    skyBlue900: '#011D23',
    // TEAL (Hue 168)
    teal050: '#C2F6EC',
    teal100: '#96EEDE',
    teal200: '#57D9C4',
    teal300: '#25C5AD',
    teal400: '#00B098',
    teal500: '#009680',
    teal600: '#007B68',
    teal700: '#006151',
    teal800: '#00473A',
    teal900: '#012C24',
    // VIOLET (Hue 290)
    violet050: '#FCEFFF',
    violet100: '#F9DFFE',
    violet200: '#E9C2F1',
    violet300: '#DAA5E4',
    violet400: '#CA87D7',
    violet500: '#B967CA',
    violet600: '#A944BD',
    violet700: '#971CB0',
    violet800: '#640D75',
    violet900: '#31013B',
    // YELLOW (Hue 57)
    yellow050: '#FFFCD1',
    yellow100: '#FEFAB3',
    yellow200: '#F2EB7B',
    yellow300: '#E6DC4C',
    yellow400: '#C8BE2F',
    yellow500: '#A9A11C',
    yellow600: '#8B8410',
    yellow700: '#6D6709',
    yellow800: '#4E4A05',
    yellow900: '#302E03',
    highlightYellow: '#FFF0A3',
    // YELLOW GREEN (Hue 64)
    yellowGreen050: '#F4F5E1',
    yellowGreen100: '#E9EBC5',
    yellowGreen200: '#D1D59E',
    yellowGreen300: '#BABE7A',
    yellowGreen400: '#A3A758',
    yellowGreen500: '#8C9138',
    yellowGreen600: '#757A1A',
    yellowGreen700: '#575C13',
    yellowGreen800: '#3A3D09',
    yellowGreen900: '#1D1E01',
    // ----------------------
    // OLD UI COLORS - should get phased out.
    barracudaBlue: '#0088CE',
    barracudaBlue40: '#99CFEB',
    barracudaBlue60: '#66B8E2',
    barracudaBlue80: '#33A0D8',
    barracudaBlueDark: '#007AB8',
    barracudaTeal: '#00B098',
    barracudaTeal40: '#99DFD6',
    barracudaTeal60: '#66D0C1',
    barracudaTeal80: '#33C0AD',
    barracudaTealDark: '#009984',
    skyBlue: '#00B5D1',
    skyBlue40: '#99E1ED',
    skyBlue60: '#66D3E3',
    skyBlue80: '#33C4DA',
    skyBlueDark: '#009CB4',
    barracudaBlack: '#000006',
    barracudaBlack30: '#B2B2B2',
    barracudaBlack50: '#7F7F82',
    barracudaBlack70: '#4C4C50',
    barracudaBlack90: '#19191E',
    backgroundDark: '#1D1E2B',
    backgroundLight: '#F7F7F7',
    disabled: '#AAAAAA',
    disabledText: '#DDDDDD',
    uiElement: '#DDDDDD',
    hoverGray: '#EDEDED',
    hoverBlue: '#D8ECF7',
    hoverBorder: '#6E6E6E',
    overlay: 'rgba(0, 0, 6, 0.5)',
    statusCritical: '#E34050',
    statusWarning: '#EEAA48',
    statusSuccess: '#95CC66',
    statusInformational: '#5F5F5F',
    bgEmailProtection: '#172619',
    bgAppCloudSecurity: '#002D3B',
    bgNetworkSecurity: '#161521',
    bgDataProtection: '#28160D',
    breakerWhite: '#FFFFFF',
    scaleGray: '#D4D4D3',
    coastalSand: '#DED9C9',
    sunriseYellow: '#FFF387',
    starfishOrange: '#FDB913',
    seagrassGreen: '#82C341',
    coralOrange: '#F05336',
    octopusPurple: '#9253A1',
    humpbackGray: '#425160',
    deepOcean: '#263146'
};
//# sourceMappingURL=colors.js.map